import { Button } from '@mui/material';
import { useScopedField } from '@ngt/forms-core';
import { FC } from 'react';

interface IPrevButtonProps {
    onClick: () => void;
}

const PrevButton: FC<IPrevButtonProps> = ({ onClick }) => {
    const { state: { value: staff } } = useScopedField<boolean>('staff', { value: true });
    const { state: { value: staffConfirmed } } = useScopedField<boolean>('staffConfirmed', { value: true });

    return (
        <Button
            variant="contained"
            color="tertiary"
            onClick={onClick}
            disabled={staff == true && staffConfirmed != true}
            sx={{
                marginTop: '20px',
                marginRight: '20px',
                float: 'right',
            }}>
            Back
        </Button>
    );
};

export default PrevButton;
